import { type InferResponseType, unwrap } from "@nexxt/api-client";
import type { ListNotificationsInput } from "@nexxt/contracts/notifications";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the emails written (FR-M14-05, ADR-149 point 9): one list by cursor, the log of every email or,
// with an entity, its history.

type ListPage = InferResponseType<typeof api.notifications.history.$get, 200>;
export type Notification = ListPage["items"][number];

export type NotificationFilters = Pick<ListNotificationsInput, "status" | "templateCode" | "entityType" | "entityId">;

const keys = { all: ["notifications"] as const };

export const notificationQueries = {
  ...keys,

  list: ({ status, templateCode, entityType, entityId }: NotificationFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", { status, templateCode, entityType, entityId }],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          api.notifications.history.$get(
            {
              query: {
                ...(status && { status }),
                ...(templateCode && { templateCode }),
                ...(entityType && { entityType }),
                ...(entityId && { entityId }),
                ...(pageParam && { cursor: pageParam }),
                limit: "50",
              },
            },
            { init: { signal } },
          ),
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),
};
